// src/commanding/nova-centralized-commanding-provider.tsx
import React from "react";
import invariant from "invariant";
var NovaCommandingContext = React.createContext(null);
var NovaCentralizedCommandingProvider = ({children, commanding}) => {
  return /* @__PURE__ */ React.createElement(NovaCommandingContext.Provider, {
    value: commanding
  }, children);
};
NovaCentralizedCommandingProvider.displayName = "NovaCentralizedCommandingProvider";
var useNovaCentralizedCommanding = () => {
  const commanding = React.useContext(NovaCommandingContext);
  invariant(commanding, "Nova Centralized Commanding provider must be initialized prior to consumption!");
  return commanding;
};
export {
  NovaCentralizedCommandingProvider,
  useNovaCentralizedCommanding
};
